// Auto-generated by RequirePageMetaPlugin
export const routeNames: Record<string, string> = {
  '/[language]/profile/account/change-password': 'Change Password',
  '/[language]/profile/account/invoice-information': 'Invoice Information',
  '/[language]/profile/account/payment-methods': 'Payment Methods',
  '/[language]/profile/account/phone-number': 'Phone Number',
  '/[language]/profile/account/privacy-settings': 'Privacy Settings',
  '/[language]/hosted-page-redirect/authorization': 'Authorization',
  '/[language]/hosted-page-redirect/tokenization': 'Tokenization',
  '/[language]/internal/address-book-desktop': 'Address Book Desktop',
  '/[language]/internal/address-book-mobile': 'Address Book Mobile',
  '/[language]/internal/checkout-migration': 'Checkout Migration',
  '/[language]/internal/prime-migration': 'Prime Migration',
  '/[language]/profile/account': 'Account',
  '/[language]/profile/language': 'Language',
  '/[language]/profile/promocodes': 'Promocodes',
  '/[language]/profile/past-orders': 'Past Orders',
  '/[language]/web-views/gifting': 'Gifting',
  '/[language]/web-views/privacy-management': 'Privacy Management',
  '/[language]/[country]/[city]/categories/[category]': 'Category',
  '/[language]/[country]/[city]/stores/[storeSlug]': 'Store',
  '/[language]/[country]/map/[cities]': 'Cities',
  '/[language]/courier-sign-contract/[id]': 'Courier Sign Contract',
  '/[language]/gifting/[id]': 'Gifting Detail',
  '/[language]/dummy': 'Dummy',
  '/[language]/gifting': 'Gifting',
  '/[language]/global-wip': 'Global WIP',
  '/[language]/glovo-card': 'Glovo Card',
  '/[language]/healthcheck': 'Healthcheck',
  '/[language]/login': 'Login',
  '/[language]/package-delivery': 'Package Delivery',
  '/[language]/password-recovery': 'Password Recovery',
  '/[language]/profile': 'Profile',
  '/[language]/security': 'Security',
  '/[language]/[country]': 'Country',
  '/[language]': 'Global',
};
